import get from 'lodash/get';
import { connect } from 'react-redux';

import NotifyErrorDataMaybeLost from './notify_error_data_maybe_lost.jsx';

import {
  getLastFailure
} from 'zoomforth_codesbane_editor/reducers/index.js';

import {
  closeModal
} from 'zoomforth_codesbane_editor/action_creators/editor_modals.js';

const mapStateToProps = (state, { httpStatusCode, serverMessage }) => {

  const clientErrorDescription = get(getLastFailure(state), 'descriptor');

  return {
    httpStatusCode,
    serverMessage,
    clientErrorDescription,
    canShowIntercom: !!window.Intercom
  };
};


const mapDispatchToProps = (dispatch) => (
  {
    onCancel: ()=> { 
      dispatch(closeModal()); 
    },
    onConfirm: ()=> { 
      window.location.reload();
    },
    onIntercomShow: ()=> {
      window.Intercom('show');
    }
  }
);

const NotifyErrorDataMaybeLostContainer = connect(
  mapStateToProps,
  mapDispatchToProps

)(NotifyErrorDataMaybeLost);

NotifyErrorDataMaybeLostContainer.editorModalName = 'NotifyErrorDataMaybeLostContainer';

export default NotifyErrorDataMaybeLostContainer;